import { useEffect, useState } from 'react';
import { Button, Modal, Textarea } from '@shared/widgets';

interface Props {
  show: boolean;
  onClose: () => void;
  onSave: (note: string) => void;
  initialCategory?: string;
}

export const AddCategoryModal = (props: Props) => {
  const [category, setCategory] = useState<string>('');

  useEffect(() => {
    if (props.show) {
      setCategory(props.initialCategory || '');
    } else {
      setCategory('');
    }
  }, [props.show]);

  return (
    <Modal isOpen={props.show} title='Category' onClose={props.onClose}>
      <div className='mb-5'>
        <Textarea fitContent placeholder='Enter your message here' value={category} onChange={setCategory} />
      </div>
      <Button color='primary' fullWidth onClick={() => props.onSave(category)}>
        Save
      </Button>
    </Modal>
  );
};
